import { isEmpty } from "@swiggy-private/core-ui";
import { CardDetails } from "@swiggy-private/payment-types";

export const getSelectedCardDetails = (
    selectedCardFingerprint: string,
    cardsList: CardDetails[],
): CardDetails | null => {
    if (!selectedCardFingerprint || isEmpty(cardsList)) {
        return null;
    }

    const cardDetails = cardsList.find(card => card.cardFingerprint === selectedCardFingerprint);

    if (!cardDetails) {
        return null;
    }

    return cardDetails;
};
